module.exports = __webpack_public_path__ + "static/media/tenancy-mobile2.4485cce8.png";